import { TYPES } from "./report.type";

// --------- change variable --------- //
export const setCompanyName =
  ({ data }, callback) =>
  (dispatch) => {
    selectCompanySuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

export const setFrom =
  ({ data }, callback) =>
  (dispatch) => {
    selectFromSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

export const setTo =
  ({ data }, callback) =>
  (dispatch) => {
    selectToSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

export const setEdit =
  ({ data }, callback) =>
  (dispatch) => {
    selectEditSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

export const setUser =
  ({ data }, callback) =>
  (dispatch) => {
    selectUserSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// --------- dispatch --------- //
const selectCompanySuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_COMPANY_NAME,
    payload: data,
  });
};

const selectFromSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_TIME_FROM,
    payload: data,
  });
};

const selectToSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_TIME_TO,
    payload: data,
  });
};

const selectEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_EDITABLE,
    payload: data,
  });
};

const selectUserSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_USER,
    payload: data,
  });
};

// ------------ Report Data function ------------ //

export const setReportData =
  ({ data }, callback) =>
  (dispatch) => {
    selectReportDataSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

export const setTotalWorking =
  ({ data }, callback) =>
  (dispatch) => {
    selectWorkingSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

export const setTotalBreaking =
  ({ data }, callback) =>
  (dispatch) => {
    selectBreakingSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

export const setRange =
  ({ data }, callback) =>
  (dispatch) => {
    selectRangeSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------ //
const selectReportDataSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_REPORT_DATA,
    payload: data,
  });
};

const selectWorkingSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_TOTAL_WORKING,
    payload: data,
  });
};

const selectBreakingSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_TOTAL_BREAKING,
    payload: data,
  });
};

const selectRangeSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_RANGE,
    payload: data,
  });
};

// ------------ Select photos , location ------------ //

export const setPhotos =
  ({ data }, callback) =>
  (dispatch) => {
    selectPhotoDataSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

export const setLocation =
  ({ data }, callback) =>
  (dispatch) => {
    selectLocationDataSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------ //
const selectPhotoDataSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_PHOTOS,
    payload: data,
  });
};

const selectLocationDataSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_LOCATION,
    payload: data,
  });
};

// ----------- Set Open Add Time -----------

export const setOpen =
  ({ data }, callback) =>
  (dispatch) => {
    selectOpenSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------ //
const selectOpenSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_OPEN,
    payload: data,
  });
};
